const COMMENT_STATUS_ALL = 'all';
const COMMENT_STATUS_APPROVED = 'approved';
const COMMENT_STATUS_PENDING = 'pending';
const COMMENT_STATUS_DELETED = 'deleted';

const PLAN_TYPE_FREE = 'free';
const PLAN_TYPE_ONE_TIME = 'one-time';
const PLAN_TYPE_INSTALLMENT_PLAN = 'installment-plan';
const PLAN_TYPE_SUBSCRIPTION = 'subscription';

const PLAN_INTERVAL_DAY = 'day';
const PLAN_INTERVAL_WEEK = 'week';
const PLAN_INTERVAL_YEAR = 'year';
const PLAN_INTERVAL_MONTH = 'month';
const PLAN_INTERVAL_QUARTER = 'quarter';
const PLAN_INTERVAL_2_WEEKS = '2-weeks';
const PLAN_INTERVAL_6_MONTHS = '6-months';

const HUB_FEATURE_TYPE_COMMUNITY = 'community';

const MEMBER_ACCOUNT_TYPE_REGULAR = 'regular';

const TRANSCRIPTION_STATUS_PREPARING_SOURCE = 'preparing_source';
const TRANSCRIPTION_STATUS_CONVERTING_FILE = 'converting_file';
const TRANSCRIPTION_STATUS_CONVERTING_FILE_FAILED = 'converting_file_failed';
const TRANSCRIPTION_STATUS_TRANSCRIPTION_PENDING = 'transcription_pending';
const TRANSCRIPTION_STATUS_SOURCE_FILE_TOO_BIG = 'source_file_too_big';
const TRANSCRIPTION_STATUS_TRANSCRIPTION_IN_PROGRESS = 'transcription_in_progress';
const TRANSCRIPTION_STATUS_TRANSCRIPTION_COMPLETED = 'transcription_completed';
const TRANSCRIPTION_STATUS_TRANSCRIPTION_FAILED = 'transcription_failed';

const ORDER_STATUS_ACTIVE = 'active';
const ORDER_STATUS_OVERDUE = 'overdue';
const ORDER_STATUS_PENDING = 'pending';
const ORDER_STATUS_COMPLETED = 'completed';
const ORDER_STATUS_REFUNDED = 'refunded';
const ORDER_STATUS_CANCELLED = 'cancelled';
const ORDER_STATUS_TRIALING = 'trialing';

export {
    COMMENT_STATUS_ALL, COMMENT_STATUS_APPROVED, COMMENT_STATUS_DELETED, COMMENT_STATUS_PENDING,
    PLAN_TYPE_FREE, PLAN_TYPE_INSTALLMENT_PLAN, PLAN_TYPE_ONE_TIME, PLAN_TYPE_SUBSCRIPTION,
    PLAN_INTERVAL_DAY, PLAN_INTERVAL_WEEK, PLAN_INTERVAL_YEAR, PLAN_INTERVAL_MONTH, PLAN_INTERVAL_QUARTER, PLAN_INTERVAL_2_WEEKS, PLAN_INTERVAL_6_MONTHS,
    HUB_FEATURE_TYPE_COMMUNITY,
    MEMBER_ACCOUNT_TYPE_REGULAR,
    TRANSCRIPTION_STATUS_PREPARING_SOURCE, TRANSCRIPTION_STATUS_CONVERTING_FILE, TRANSCRIPTION_STATUS_CONVERTING_FILE_FAILED, TRANSCRIPTION_STATUS_TRANSCRIPTION_PENDING, TRANSCRIPTION_STATUS_SOURCE_FILE_TOO_BIG, TRANSCRIPTION_STATUS_TRANSCRIPTION_IN_PROGRESS, TRANSCRIPTION_STATUS_TRANSCRIPTION_COMPLETED, TRANSCRIPTION_STATUS_TRANSCRIPTION_FAILED,
    ORDER_STATUS_ACTIVE, ORDER_STATUS_OVERDUE, ORDER_STATUS_PENDING, ORDER_STATUS_COMPLETED, ORDER_STATUS_REFUNDED, ORDER_STATUS_CANCELLED, ORDER_STATUS_TRIALING,
}